<template>
  <div class="member-vip-list">
    <div class="member-vip" v-for="vip in teacherVipConfigs" :key="vip.type" v-show="vipType.type === vip.type">
      <div class="recommend-tag" v-if="isRecommend.includes('recommend')">推荐</div>
      <div class="top-box">
        <h4>{{ vip.title }}</h4>
        <div class="member-vip-panel">
          <strong>
            <span class="price-prev"></span>
            <span class="price">{{ vip.price }}</span>
            <span class="price-unit">{{ vip.unit }}</span>
          </strong>
          <p class="desc">{{ vip.description }}</p>
          <button class="upgrade-btn upgrade-plus" @click="getTeacherVip(vip.type)">开通教师会员</button>
        </div>
      </div>
      <div class="bottom-box">
        <div>
          <h5><i class="icon el-icon-document-copy"></i><span>内容服务</span></h5>
          <div class="box_item">
            <span class="item_txt" style="width: 70%;text-align: left;">免费和VIP试卷</span>
            <b class="item_select">{{ vip.dailyLimit }}</b>
          </div>
          <div class="box_item">
            <span class="item_txt" style="width: 70%;text-align: left;">教师账号</span>
            <b class="item_select">{{ vip.teacherAccounts }}</b>
          </div>
          <div class="box_item">
            <span class="item_txt" style="width: 70%;text-align: left;">学生账号</span>
            <b class="item_select">{{ vip.studentAccounts }}</b>
          </div>
          <div class="box_item">
            <span class="item_txt">教师会员有效期</span>
            <b class="item_select">{{ vip.teacherPeriod }}</b>
          </div>
          <div class="box_item">
            <span class="item_txt">学生会员有效期</span>
            <b class="item_select">{{ vip.studentPeriod }}</b>
          </div>
          <div class="box_item">
            <span class="item_txt">题库答题</span>
            <b class="primary-color6 item_select">无限次</b>
          </div>
          <div class="box_item">
            <span class="item_txt">查看试题答案/解析</span>
            <b class="primary-color6 item_select">无限次</b>
          </div>
        </div>
        <div>
          <h5><img src="@/assets/vip.svg"><span>尊享服务</span></h5>
          <div v-for="service in vip.services" :key="service.name" class="box_item">
            <span class="item_txt">{{ service.name }}</span>
            <b :class="service.enabled ? 'el-icon-check icon-right' : 'el-icon-close icon-right'"></b>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
        title="提示"
        width="30%"
    >
      <span>这是一段信息</span>
    </el-dialog>
  </div>
</template>

<script>
import {
  openTeacherVip,
  getUserTypeList
} from "@/api/index.js"

// 静态缓存，防止重复请求
const priceCache = {
  teacher: {
    loading: false,
    data: null,
    promise: null
  }
}

export default {
  filters: {
    formatType(type) {
      switch (type) {
        case 1:
          return "会员"
          break;
        case 2:
          return "会员"
          break;
        case 3:
          return "会员-周"
          break;
        case 4:
          return "会员-月"
          break;
        case 5:
          return "会员-年"
          break;
        case 6:
          return "会员-3年"
          break;
        case 7:
          return "会员-3月"
          break;
        default:
          break;
      }
    }
  },
  props: {
    isRecommend: {
      type: String,
      default: 'selfVipCard'
    },
    vipType: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      userVipType: null,
      userId: 1,
      radio1: 'Scratch',
      value: '1',
      options: [{
        value: '1',
        label: '一级'
      }, {
        value: '2',
        label: '二级'
      }, {
        value: '3',
        label: '三级'
      }, {
        value: '4',
        label: '四级'
      }],
      teacherVipConfigs: [
        {
          type: 4,
          title: '月会员',
          price: '199',
          unit: '元/月',
          description: '全站试题免费作答，试卷每日15次免费作答',
          dailyLimit: '15次/天/账号',
          teacherAccounts: '1个',
          studentAccounts: '5个',
          teacherPeriod: '30天',
          studentPeriod: '30天',
          services: [
            { name: '教师和学生账号全站均可作答', enabled: true },
            { name: 'VIP专享文档', enabled: true },
            { name: '试卷下载', enabled: true },
            { name: '精品专辑', enabled: true },
            { name: '录题/组卷', enabled: false }
          ]
        },
        {
          type: 7,
          title: '季度会员',
          price: '399',
          unit: '元/季',
          description: '全站试题免费作答，试卷每日20次免费作答',
          dailyLimit: '20次/天/账号',
          teacherAccounts: '1个',
          studentAccounts: '10个',
          teacherPeriod: '3个月',
          studentPeriod: '3个月',
          services: [
            { name: '教师和学生账号全站均可作答', enabled: true },
            { name: 'VIP专享文档', enabled: true },
            { name: '试卷下载', enabled: true },
            { name: '精品专辑', enabled: true },
            { name: '录题/组卷', enabled: true }
          ]
        },
        {
          type: 5,
          title: 'PLUS年会员',
          price: '999',
          unit: '元/年',
          description: '全站试题免费作答，试卷每日30次免费作答',
          dailyLimit: '30次/天/账号',
          teacherAccounts: '2个',
          studentAccounts: '50个',
          teacherPeriod: '一年',
          studentPeriod: '一年',
          services: [
            { name: '教师和学生账号全站均可作答', enabled: true },
            { name: 'VIP专享文档', enabled: true },
            { name: '试卷下载', enabled: true },
            { name: '精品专辑', enabled: true },
            { name: '录题/组卷', enabled: true }
          ]
        },
        {
          type: 6,
          title: '尊享三年会员',
          price: '2999',
          unit: '元/3年',
          description: '全站试题免费作答，试卷每日30次免费作答',
          dailyLimit: '30次/天/账号',
          teacherAccounts: '5个',
          studentAccounts: '200个',
          teacherPeriod: '三年',
          studentPeriod: '三年',
          services: [
            { name: '教师和学生账号全站均可作答', enabled: true },
            { name: 'VIP专享文档', enabled: true },
            { name: '试卷下载', enabled: true },
            { name: '精品专辑', enabled: true },
            { name: '录题/组卷', enabled: true }
          ]
        }
      ]
    }
  },
  mounted() {
    this.userVipType = this.vipType.type
    this.userId = localStorage.getItem("userId")
    this.fetchVipPrices()
  },
  methods: {
    // 获取会员价格
    fetchVipPrices() {
      const cache = priceCache.teacher
      
      // 如果已有缓存数据，直接使用
      if (cache.data) {
        this.updateVipPrices(cache.data)
        return
      }
      
      // 如果正在请求中，等待请求完成
      if (cache.loading && cache.promise) {
        cache.promise.then(data => {
          if (data) {
            this.updateVipPrices(data)
          }
          // 如果失败，data 为 null，保持原有价格不变
        }).catch(() => {
          // 请求失败，保持原有价格不变
        })
        return
      }
      
      // 发起新请求
      cache.loading = true
      cache.promise = getUserTypeList('teacher').then(res => {
        cache.loading = false
        if (res.code === '0000' && res.data && res.data.length > 0) {
          cache.data = res.data
          this.updateVipPrices(res.data)
          return res.data
        } else {
          // 接口返回错误，保持原有价格不变
          return null
        }
      }).catch(err => {
        cache.loading = false
        cache.promise = null
        // 请求失败，保持原有价格不变，不更新数据
        console.error('获取会员价格失败，使用默认价格:', err)
        return null
      })
    },
    // 更新会员价格
    updateVipPrices(data) {
      if (!data || !Array.isArray(data)) return
      
      data.forEach(item => {
        const config = this.teacherVipConfigs.find(vip => {
          // 根据 typeName 匹配
          if (item.typeName === '月会员' && vip.type === 4) return true
          if (item.typeName === '季度会员' && vip.type === 7) return true
          if (item.typeName === 'PLUS年会员' && vip.type === 5) return true
          if (item.typeName === '尊享三年会员' && vip.type === 6) return true
          return false
        })
        
        if (config) {
          // 更新价格信息
          config.price = item.price.toString()
          
          // 根据 durationUnit 生成单位
          let unit = ''
          if (item.durationUnit === 'month') {
            unit = item.durationValue === 1 ? '元/月' : `元/${item.durationValue}月`
          } else if (item.durationUnit === 'year') {
            unit = item.durationValue === 1 ? '元/年' : `元/${item.durationValue}年`
          } else if (item.durationUnit === 'day') {
            unit = item.durationValue === 1 ? '元/天' : `元/${item.durationValue}天`
          } else {
            unit = config.unit // 保持原有单位
          }
          config.unit = unit
          
          // 更新每日限制
          if (item.dailyFreeTimes) {
            config.dailyLimit = `${item.dailyFreeTimes}次/天/账号`
          }
        }
      })
    },
    getTeacherVip(vipType) {
      let param = {
        userId: Number(this.userId),
        userVipType: vipType.toString(),
        name: this.radio1,
        level: this.value
      }
      openTeacherVip(param).then(res => {
        if (res.code === "0000") {
          const div = document.createElement('div');
          /* 此处form就是后台返回接收到的数据 */
          div.innerHTML = res.data;
          document.body.appendChild(div);

          // 2. 移除表单自带的自动提交脚本（关键：避免提前提交）
          const scripts = div.querySelectorAll('script');
          scripts.forEach(script => script.remove());

          // 3. 等待Vue DOM更新完成后再操作（比setTimeout更可靠）
          this.$nextTick(() => {
            // 4. 明确获取表单（优先用ID，避免索引问题）
            const form = div.querySelector('form[name="punchout_form"]') || document.forms[0];
            if (form) {
              // 强制设置属性（覆盖默认值）
              form.target = '_blank'; // 确保新窗口打开
              form.acceptCharset = 'utf-8';
              // 手动提交
              form.submit();

              // 5. 提交后清理临时DOM（避免残留）
              setTimeout(() => {
                document.body.removeChild(div);
              }, 500);
            }
          });
        }
      })
    },
  }
}
</script>

<style>
.bottom-box .box_item {
  line-height: 36px;
  font-size: 0;
  color: #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.box_item > .item_txt {
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.box_item > .item_select,
.box_item .icon-right {
  flex-shrink: 0;
  text-align: right;
  font-weight: normal;
  white-space: nowrap;
  margin-left: 8px;
}

</style>

<style lang="scss" scoped>

h3 {
  font-size: 26px;
  text-align: center;
  margin: 25px 0 13px;
  font-weight: bold;
  color: rgba(50, 26, 0, 1);
  line-height: 35px;
  letter-spacing: 2px;
  padding-top: 20px;
}

.orange {
  color: #CC7400;
}

.price {
  height: 70px;
  font-size: 50px;
  text-align: center;
  margin-bottom: 20px;
}

.sears .price span {
  font-size: 16px;
  color: #321A00;
  font-weight: 600;
  position: relative;
}

.price .year {
  vertical-align: 1px;
  margin-left: 3px;
}

.selfVipCard {
  width: 300px;
  height: 600px;
  background-color: #FFFFFF;
  overflow: hidden;
  position: relative;
  border-radius: 5px;
  box-shadow: 2px 2px 2px #64390F;
  border: 1px solid #FFFFFF;
  transition: all .1s ease-in;
}

.selfVipCard:hover {
  border: 3px solid #64390F;
  // border-top: 2px solid #FF69B4;
  transform: translateY(-10px);
  box-sizing: border-box;
  box-shadow: 5px 5px 2px #64390F;
}

.recommend::before {
  content: "";
  position: absolute;
  width: 30px;
  height: 180px;
  background-color: #64390F;
  transform: rotate(45deg);
  top: -50px;
}

.recommend::after {
  content: "推 荐";
  color: #FFFFFF;
  transform: rotate(-45deg);
  width: 50px;
  height: 30px;
  left: 8px;
  top: 12px;
  position: absolute;
  font-weight: 900;
  font-size: 18px;
  // margin-top: -20px;
}

.origin-price-show {
  opacity: 1;
  font-size: 16px;
  color: #A5A5A5;
  width: 80%;
}

.iconfont {
  color: #FF0000;
  font-size: 18px;
  position: relative;
}

.limit-c {
  // float: right;
  color: #FF0000;
  font-size: 12px;
  line-height: 22px;
}

* {
  margin: 0;
  padding: 0;
}

.member-vip-list {
  display: flex;
  margin-top: 40px;

  .member-vip {
    width: 285px;
    background-color: #fff;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    flex: none;
    border-radius: 12px;
    margin-right: 0;
    position: relative;
    transition: all 0.3s ease;

    .recommend-tag {
      position: absolute;
      top: 0;
      right: 0;
      background: linear-gradient(135deg, #ff6b00, #ff9500);
      color: #fff;
      font-size: 12px;
      font-weight: 600;
      padding: 4px 12px;
      border-radius: 0 12px 0 12px;
      z-index: 10;
      box-shadow: 0 2px 8px rgba(255, 107, 0, 0.3);
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    }

    .top-box {
      width: 100%;
      box-sizing: border-box;
      padding: 24px 16px 20px;
      text-align: center;
      border-radius: 12px 12px 0 0;
      background: linear-gradient(180deg, #fff5eb 0%, #ffefe0 100%);

      h4 {
        font-family: PingFangSC-Semibold, Microsoft YaHei, Arial, Helvetica, sans-serif;
        margin: 0 0 16px 0;
        font-size: 18px;
        line-height: 1;
        font-weight: 600;
        color: #994b00;
      }

      .member-vip-panel {
        font-family: PingFangSC-Regular, Microsoft YaHei, Arial, Helvetica, sans-serif;
        width: 100%;
        text-align: center;

        .price {
          color: #cc5500;
          font-size: 40px;
          font-weight: 700;
          line-height: 1.2;
        }

        .price-unit {
          color: #994b00;
          font-size: 14px;
          font-weight: 500;
        }

        .desc {
          font-size: 13px;
          color: #666;
          margin: 10px 0 16px;
          line-height: 1.4;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .upgrade-btn {
          background: #ff7f14;
          color: white;
          width: 90%;
          max-width: 220px;
          height: 40px;
          font-size: 14px;
          font-family: PingFangSC-Semibold, Microsoft YaHei, Arial, Helvetica, sans-serif;
          font-weight: 600;
          line-height: 40px;
          cursor: pointer;
          border-radius: 20px;
          border: 0;
          outline: 0;
          transition: background 0.3s;

          &:hover {
            background: #e56a00;
          }
        }
      }
    }


    .bottom-box {
      box-sizing: border-box;
      padding: 16px;
      background: #fff;

      div > h5 {
        height: auto;
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 600;
        color: #994b00;
        display: flex;
        align-items: center;
        margin-block-start: 10px;
        margin-inline-start: 0;
        margin-inline-end: 0;

        img {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
      }

      div > h5 > i {
        display: inline-block;
        vertical-align: middle;
        margin-right: 6px;
        font-size: 14px;
      }

      .primary-color6 {
        color: #ff7f14;
      }
    }

    .bottom-box .box_item > .item_txt,
    .bottom-box .box_item > b {
      display: inline-block;
      vertical-align: middle;
      font-size: 13px;
    }
  }
}

</style>
